import { render, staticRenderFns } from "./DiagnosisItem.vue?vue&type=template&id=77406cc9&scoped=true&"
import script from "./DiagnosisItem.vue?vue&type=script&lang=js&"
export * from "./DiagnosisItem.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosisItem.vue?vue&type=style&index=0&id=77406cc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77406cc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VListItemContent,VRow})
